import React, { Component, PropTypes } from 'react';
import { Menu, Button, Modal, Spin, Select, Radio, DatePicker, Alert, Input, Form, InputNumber, Upload, Icon } from 'antd';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import { getBase64, stripBase64FileType } from 'utils/getBase64Img';
// import ClassSchedulesTab from './ClassSchedules';
// import ClassReviewsTab from './ClassReviews';

import { connect } from 'react-redux';

import { getOrderItemById, editOrderItemById } from 'data/order-item';
import Utils from 'utils/utils';
import { formItemLayout } from 'constants/layout';
import Dropzone from 'react-dropzone';

import OrderItemInfoHeader from './OrderItemInfoHeader';
import OrderRevenueTab from './OrderRevenue';

import classes from '../styles/order/OrderInfo.module.scss';

// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;

const { TextArea } = Input;
const Confirm = Modal.confirm;

const TABS = [{ label: 'Info', value: 'info' }];

class OrderItemInfo extends Component {
  constructor(props) {
    super(props);
    this.onChangeFocusTab = this.onChangeFocusTab.bind(this);

    // props.getAutocompleteTeachers(props.classroom.owner.displayName);
    if (browserHistory) {
      this.backListener = browserHistory.listen((location) => {
        if (location.action === 'POP') {
          this.setState({ selectedTab: location.query.selectedTab ? location.query.selectedTab : 'info' });
        }
      });
    }

    this.state = {
      collapseMobile: [],
      mode: 'editor',
      isShowEditPaymentModal: false,
      selectedTab: props.location.query.selectedTab ? props.location.query.selectedTab : 'info',
    };
  }

  componentDidMount = async () => {
    const orderItemId = this.props.params.orderItemId;

    const orderItem = await getOrderItemById(orderItemId);
    this.setState({ orderItem });
    // return Promise.all(promises);
  };

  componentWillUnmount() {
    this.backListener();
  }

  onChangeFocusTab(tab) {
    this.setState({ selectedTab: tab.key });
    browserHistory.push(`${this.props.location.pathname}?selectedTab=${tab.key}`);
  }

  handleSubmit = () => {
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        const newOrder = { remark: values.remark };

        await editOrderItemById(_.get(this.props, 'order._id'), newOrder);
        const orderItem = await getOrderItemById(_.get(this.props, 'order._id'));

        this.setState({
          isShowRemarkModal: false,
          orderItem,
        });
        // browserHistory.push('/order');
      }
    });
  };

  showRefundConfirm = () => {
    Confirm({
      title: 'Do you want to reject?',
      // content: content || '',
      onOk: () => {
        const id = this.state.orderItem._id;
        this.props.refundOrder(id).then(() => {
          this.props.getOrderById(id);
          // this.getOrders(this.getCurrentQuery()).then(_.noop);
        });
      },
      // onCancel: this.onCancel,
    });
  };

  renderEditRemarkModal() {
    const { getFieldDecorator } = this.props.form;
    console.log(this.state.isShowRemarkModal);

    return (
      <Modal
        title={'Edit Remark'}
        visible={this.state.isShowRemarkModal}
        onCancel={() => this.setState({ isShowRemarkModal: false })}
        footer={[
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleSubmit}>
            Save
          </Button>,
          <Button key="back" size="large" onClick={this.props.handleCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="Remark" hasFeedback>
            {getFieldDecorator('remark', {
              initialValue: this.state.orderItem.remark,
            })(<TextArea />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderTabs() {
    return (
      <Menu onClick={this.onChangeFocusTab} selectedKeys={[this.state.selectedTab]} mode="horizontal">
        {TABS.map((tab) => (
          <Menu.Item key={tab.value} className={classes.menuItem}>
            <div>{tab.label}</div>
          </Menu.Item>
        ))}
      </Menu>
    );
  }

  render() {
    // console.log(this.state.files);
    const { loading } = this.props;

    if (!this.state.orderItem) {
      return <div></div>;
    }

    return (
      <div>
        <Spin tip="Loading" size="large" spinning={!!loading}>
          <div className="page-header">
            {this.props.BreadCrumb}
            <OrderItemInfoHeader orderItem={this.state.orderItem} onOpenRefundModal={() => this.showRefundConfirm()} onOpenRemarkModal={() => this.setState({ isShowRemarkModal: true })} />
          </div>
          {this.state.selectedTab === 'info' && (
            <OrderRevenueTab
              orderItem={this.state.orderItem}
              openEditPaymentModal={() => this.setState({ isShowEditPaymentModal: true })}
              onApproveOrder={this.onApproveOrder}
              onCancelOrder={this.showCancelConfirm}
            />
          )}
          {this.renderEditRemarkModal()}
        </Spin>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    // pages: state.content.pages,
    // schedule: state.order.order.schedule,
    // order: state.order.order,
    // classroom: state.order.order.class,
  }),
  {},
)(Form.create()(OrderItemInfo));
